module.exports = __webpack_public_path__ + "img/poa.a7edf9be.svg";